module.exports = {"141081001":"路东街道","141081002":"路西街道","141081003":"浍滨街道","141081004":"上马街道","141081005":"张村街道","141081200":"新田乡","141081201":"高村乡","141081202":"凤城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141081.json
// module id = 464
// module chunks = 0